var _path, _feFlood, _feGaussianBlur, _feComposite, _feBlend, _feFlood2, _feBlend2, _feGaussianBlur2, _feFlood3, _feGaussianBlur3, _feComposite2, _feBlend3, _stop, _stop2, _stop3, _stop4, _stop5, _stop6, _stop7, _stop8, _stop9, _stop10, _stop11, _stop12, _stop13, _stop14, _stop15, _stop16, _stop17, _stop18, _stop19, _stop20, _stop21, _stop22, _stop23, _stop24, _stop25, _stop26, _stop27, _stop28, _stop29, _stop30, _stop31, _stop32, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
var SvgContentError = function SvgContentError(props) {
  var _id18 = useUniqueInlineId();
  var _id17 = useUniqueInlineId();
  var _id16 = useUniqueInlineId();
  var _id15 = useUniqueInlineId();
  var _id14 = useUniqueInlineId();
  var _id13 = useUniqueInlineId();
  var _id12 = useUniqueInlineId();
  var _id11 = useUniqueInlineId();
  var _id10 = useUniqueInlineId();
  var _id9 = useUniqueInlineId();
  var _id8 = useUniqueInlineId();
  var _id7 = useUniqueInlineId();
  var _id6 = useUniqueInlineId();
  var _id5 = useUniqueInlineId();
  var _id4 = useUniqueInlineId();
  var _id3 = useUniqueInlineId();
  var _id2 = useUniqueInlineId();
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 120,
    viewBox: "0 0 168 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id18, ")")
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.449 42.2247C118.559 40.8294 117.456 39.6367 116.056 39.6367H38.8323C37.395 39.6367 36.28 40.8914 36.4489 42.3187L43.5165 102.06C43.6594 103.268 44.6835 104.178 45.8999 104.178H111.362C112.615 104.178 113.657 103.215 113.755 101.966L118.449 42.2247Z",
    fill: "url(#".concat(_id4, ")"),
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.449 42.2247C118.559 40.8294 117.456 39.6367 116.056 39.6367H38.8323C37.395 39.6367 36.28 40.8914 36.4489 42.3187L43.5165 102.06C43.6594 103.268 44.6835 104.178 45.8999 104.178H111.362C112.615 104.178 113.657 103.215 113.755 101.966L118.449 42.2247Z",
    fill: "url(#".concat(_id5, ")"),
    fillOpacity: 0.44
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#".concat(_id, ")")
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.904 53.0854C134.414 51.4068 134.669 50.5674 134.489 49.9018C134.331 49.3188 133.959 48.8168 133.447 48.496C132.863 48.1297 131.986 48.1294 130.231 48.1288L55.3999 48.1043C54.2357 48.104 53.6536 48.1038 53.1827 48.3162C52.7676 48.5034 52.4143 48.8049 52.1641 49.1854C51.8803 49.6171 51.7889 50.1919 51.6062 51.3417L43.9139 99.7502C43.6708 101.28 43.5493 102.045 43.7741 102.64C43.9714 103.163 44.3448 103.6 44.83 103.877C45.3829 104.193 46.1574 104.193 47.7063 104.193H115.526C116.547 104.193 117.058 104.193 117.49 104.019C117.87 103.866 118.205 103.617 118.463 103.298C118.754 102.936 118.903 102.447 119.2 101.469L133.904 53.0854Z",
    fill: "url(#".concat(_id6, ")"),
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.904 53.0854C134.414 51.4068 134.669 50.5674 134.489 49.9018C134.331 49.3188 133.959 48.8168 133.447 48.496C132.863 48.1297 131.986 48.1294 130.231 48.1288L55.3999 48.1043C54.2357 48.104 53.6536 48.1038 53.1827 48.3162C52.7676 48.5034 52.4143 48.8049 52.1641 49.1854C51.8803 49.6171 51.7889 50.1919 51.6062 51.3417L43.9139 99.7502C43.6708 101.28 43.5493 102.045 43.7741 102.64C43.9714 103.163 44.3448 103.6 44.83 103.877C45.3829 104.193 46.1574 104.193 47.7063 104.193H115.526C116.547 104.193 117.058 104.193 117.49 104.019C117.87 103.866 118.205 103.617 118.463 103.298C118.754 102.936 118.903 102.447 119.2 101.469L133.904 53.0854Z",
    fill: "url(#".concat(_id7, ")")
  })), /*#__PURE__*/React.createElement("mask", {
    id: "contentError_svg__mask0_307_14223",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 48,
    width: 92,
    height: 57
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.586 50.8402C134.996 49.4916 133.987 48.13 132.578 48.1296L54.1703 48.1039C52.9899 48.1036 51.9845 48.9615 51.7992 50.1273L43.6492 101.416C43.4176 102.874 44.5437 104.193 46.0195 104.193H116.593C117.65 104.193 118.582 103.502 118.89 102.491L134.586 50.8402Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#contentError_svg__mask0_307_14223)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#".concat(_id2, ")")
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.43 48.1033L110.515 104.193H43.2079L37.2147 48.1033H117.43Z",
    fill: "url(#".concat(_id8, ")"),
    fillOpacity: 0.3
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M166.297 34.8878C149.24 75.1493 121.733 101.12 80.3958 80.8351C39.0586 60.5507 16.1618 61.78 -4.43001 88.9796",
    stroke: "url(#".concat(_id9, ")"),
    strokeWidth: 7.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.297 34.8878C149.24 75.1493 121.733 101.12 80.3958 80.8351C39.0586 60.5507 16.1618 61.78 -4.43001 88.9796",
    stroke: "url(#".concat(_id10, ")"),
    strokeOpacity: 0.45,
    strokeWidth: 7.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.5603,
    y: 30.425,
    width: 50.85,
    height: 62.1,
    rx: 2.4,
    transform: "rotate(15 77.5603 30.425)",
    fill: "url(#".concat(_id11, ")"),
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.5603,
    y: 30.425,
    width: 50.85,
    height: 62.1,
    rx: 2.4,
    transform: "rotate(15 77.5603 30.425)",
    fill: "url(#".concat(_id12, ")"),
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#".concat(_id3, ")")
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 29.15C41 27.8245 42.0745 26.75 43.4 26.75H83.5929L104.202 47.3595V101.75C104.202 103.075 103.128 104.15 101.802 104.15H43.4C42.0745 104.15 41 103.075 41 101.75V29.15Z",
    fill: "url(#".concat(_id13, ")"),
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 29.15C41 27.8245 42.0745 26.75 43.4 26.75H83.5929L104.202 47.3595V101.75C104.202 103.075 103.128 104.15 101.802 104.15H43.4C42.0745 104.15 41 103.075 41 101.75V29.15Z",
    fill: "url(#".concat(_id14, ")")
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M68.564 55.4752C68.3546 53.1602 70.1776 51.1648 72.5021 51.1648C74.8265 51.1648 76.6496 53.1602 76.4402 55.4752L74.9554 71.8906C74.8405 73.1599 73.7765 74.132 72.5021 74.132C71.2276 74.132 70.1636 73.1599 70.0488 71.8906L68.564 55.4752Z",
    fill: "url(#".concat(_id15, ")")
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.8,
    cx: 72.503,
    cy: 79.1525,
    rx: 2.59679,
    ry: 2.59679,
    fill: "url(#".concat(_id16, ")")
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M83.5273 26.75L104.137 47.3595H85.9273C84.6019 47.3595 83.5273 46.285 83.5273 44.9595V26.75Z",
    fill: "url(#".concat(_id17, ")")
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: _id,
    x: 41.2795,
    y: 45.7282,
    width: 95.6431,
    height: 60.8406,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, _feFlood || (_feFlood = /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  })), _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.188
  })), _feComposite || (_feComposite = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_307_14223"
  })), _feBlend || (_feBlend = /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_307_14223",
    result: "shape"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: _id2,
    x: 33.8731,
    y: 44.7615,
    width: 86.8991,
    height: 62.7731,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, _feFlood2 || (_feFlood2 = /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  })), _feBlend2 || (_feBlend2 = /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  })), _feGaussianBlur2 || (_feGaussianBlur2 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.67087,
    result: "effect1_foregroundBlur_307_14223"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: _id3,
    x: 38.6,
    y: 24.35,
    width: 68.0024,
    height: 82.1999,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, _feFlood3 || (_feFlood3 = /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  })), _feGaussianBlur3 || (_feGaussianBlur3 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.2
  })), _feComposite2 || (_feComposite2 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_307_14223"
  })), _feBlend3 || (_feBlend3 = /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_307_14223",
    result: "shape"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id4,
    x1: 36.1316,
    y1: 99.678,
    x2: 43.2233,
    y2: 34.6551,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8F1FF"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7DDFF"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id5,
    x1: 36.1316,
    y1: 99.678,
    x2: 43.2233,
    y2: 34.6551,
    gradientUnits: "userSpaceOnUse"
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8F1FF"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7DDFF"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id6,
    x1: 148.267,
    y1: 52.014,
    x2: 143.451,
    y2: 108.786,
    gradientUnits: "userSpaceOnUse"
  }, _stop5 || (_stop5 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E6FF"
  })), _stop6 || (_stop6 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7EC2FF"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id7,
    x1: 56.0653,
    y1: 44.1925,
    x2: 145.368,
    y2: 64.6631,
    gradientUnits: "userSpaceOnUse"
  }, _stop7 || (_stop7 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEDEFF",
    stopOpacity: 0.239973
  })), _stop8 || (_stop8 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AED9FF"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id8,
    x1: 70.5356,
    y1: 117.621,
    x2: 49.7777,
    y2: 55.622,
    gradientUnits: "userSpaceOnUse"
  }, _stop9 || (_stop9 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60B0EF"
  })), _stop10 || (_stop10 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91CFFF",
    stopOpacity: 0.01
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id9,
    x1: 162.878,
    y1: -19.1722,
    x2: 21.1453,
    y2: -37.2501,
    gradientUnits: "userSpaceOnUse"
  }, _stop11 || (_stop11 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6D9FF",
    stopOpacity: 0.01
  })), _stop12 || (_stop12 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.354194,
    stopColor: "#FFCEFA",
    stopOpacity: 0.529671
  })), _stop13 || (_stop13 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.706556,
    stopColor: "#CDC8FE",
    stopOpacity: 0.410846
  })), _stop14 || (_stop14 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9C6FF",
    stopOpacity: 0.01
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id10,
    x1: 169.478,
    y1: -7.17217,
    x2: 30.2376,
    y2: -36.8035,
    gradientUnits: "userSpaceOnUse"
  }, _stop15 || (_stop15 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFD9FF",
    stopOpacity: 0.01
  })), _stop16 || (_stop16 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.364703,
    stopColor: "#F6E5FF"
  })), _stop17 || (_stop17 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.737238,
    stopColor: "#ECEAFF",
    stopOpacity: 0.985625
  })), _stop18 || (_stop18 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id11,
    x1: 128.41,
    y1: 88.1952,
    x2: 117.933,
    y2: 26.6719,
    gradientUnits: "userSpaceOnUse"
  }, _stop19 || (_stop19 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8F1FF"
  })), _stop20 || (_stop20 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7DDFF"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id12,
    x1: 70.4694,
    y1: 34.7549,
    x2: 80.9467,
    y2: 96.2782,
    gradientUnits: "userSpaceOnUse"
  }, _stop21 || (_stop21 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF7FF"
  })), _stop22 || (_stop22 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D3FF"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id13,
    x1: 32.1866,
    y1: 32.1466,
    x2: 45.2796,
    y2: 108.816,
    gradientUnits: "userSpaceOnUse"
  }, _stop23 || (_stop23 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E6FF"
  })), _stop24 || (_stop24 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7EC2FF"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id14,
    x1: 95.389,
    y1: 21.3534,
    x2: 31.7823,
    y2: 28.5962,
    gradientUnits: "userSpaceOnUse"
  }, _stop25 || (_stop25 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEDEFF",
    stopOpacity: 0.239973
  })), _stop26 || (_stop26 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AED9FF"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id15,
    x1: 76.1376,
    y1: 72.3697,
    x2: 66.0237,
    y2: 51.5054,
    gradientUnits: "userSpaceOnUse"
  }, _stop27 || (_stop27 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF9FF"
  })), _stop28 || (_stop28 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF7FF"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id16,
    x1: 75.0998,
    y1: 81.3871,
    x2: 74.3756,
    y2: 76.1935,
    gradientUnits: "userSpaceOnUse"
  }, _stop29 || (_stop29 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF9FF"
  })), _stop30 || (_stop30 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF7FF"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id17,
    x1: 104.137,
    y1: 45.9225,
    x2: 101.263,
    y2: 25.313,
    gradientUnits: "userSpaceOnUse"
  }, _stop31 || (_stop31 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF9FF"
  })), _stop32 || (_stop32 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF7FF"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: _id18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 168,
    height: 120,
    fill: "white"
  })))));
};
export default SvgContentError;